const getCookie = (cname) => {
  let name = cname + '='
  var ca = document.cookie.split(';')
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i].trim()
    if (c.indexOf(name) == 0) return c.substring(name.length, c.length)
  }
  return ''
}

const setCookie = (name, value) => {
  let expiredays = 30
  let exdate = new Date()
  exdate.setDate(exdate.getDate() + expiredays)
  document.cookie = name + '=' + escape(value) + ((expiredays == null) ? '' : ';expires=' + exdate.toGMTString())
}

export {
  getCookie,
  setCookie
}



// WEBPACK FOOTER //
// ./src/libs/utils/cookie.js